import type { DataRegion, ManagedTeamRegion } from './team.types';

export const getPartnerRegionStorageKey = ({
  teamId,
  userId,
}: {
  teamId: string;
  userId: string;
}) => `${userId}_${teamId}_data_region`;

export const resolvePartnerRegion = ({
  managedTeamRegions,
  persistedDataRegion,
}: {
  managedTeamRegions: readonly ManagedTeamRegion[];
  persistedDataRegion: DataRegion | null | undefined;
}): ManagedTeamRegion | null => {
  const persistedRegion = managedTeamRegions.find(
    (region) => region.dataRegion === persistedDataRegion
  );
  if (persistedRegion) return persistedRegion;

  return managedTeamRegions[0] ?? null;
};
